import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider, useAuth } from "@/state/AuthProvider";
import { AppStateProvider } from "@/state/AppStateProvider";
import { AppShell } from "@/components/shell/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Create from "@/pages/Create";
import AgentRun from "@/pages/AgentRun";
import ManualPost from "@/pages/ManualPost";
import BlogList from "@/pages/BlogList";
import BlogStudio from "@/pages/BlogStudio";
import Repurposer from "@/pages/Repurposer";
import ContentInbox from "@/pages/ContentInbox";
import CalendarPage from "@/pages/Calendar";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import LibraryPage from "@/pages/Library";
import AssetDetail from "@/pages/AssetDetail";
import Skills from "@/pages/Skills";
import Brands from "@/pages/Brands";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";

function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />;
}

// Real guard for the app shell: an unauthenticated visitor is sent to /login.
function RequireAuth() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;  // wait for the boot token check before deciding
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} disableTransitionOnChange>
      <AuthProvider>
        <AppStateProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route element={<RequireAuth />}>
            <Route element={<AppShell />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/create" element={<Create />} />
              <Route path="/runs/:id" element={<AgentRun />} />
              <Route path="/runs" element={<AgentRun />} />
              <Route path="/manual-post" element={<ManualPost />} />
              <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:id" element={<BlogStudio />} />
              <Route path="/repurpose" element={<Repurposer />} />
              <Route path="/inbox" element={<ContentInbox />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/library" element={<LibraryPage />} />
              <Route path="/library/:id" element={<AssetDetail />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            </Route>
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </BrowserRouter>
        </AppStateProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
